import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getJobByTypeCount } from "../../slice/workerJobSlice";

const WorkerJobByTypeCount = () => {
    const dispatch = useDispatch();
    const token = localStorage.getItem("token");

    const { jobByTypeCount, loading, error } = useSelector(
        (state) => state.workerJob
    );

    useEffect(() => {
        if (!token) return;
        dispatch(getJobByTypeCount(token));
    }, [token, dispatch]);

    // if (loading) return <p>Loading...</p>;
    // if (error) return <p className="text-danger">{error}</p>;

    // Default types
    const defaultTypes = ["full-time", "part-time", "internship"];

    // Merge API data with defaults
    const jobsWithDefaults = defaultTypes.map((type) => {
        const found = jobByTypeCount?.find((job) => job.job_type === type);
        return {
            job_type: type,
            total: found ? found.total : 0,
        };
    });

    return (
        <div className="col-md-8 col-xl-9 mt-4 mt-md-0">
            <div className="ps-2 ps-lg-4">
                <h4 className="fw-bold text-primary mb-4 border-bottom pb-3">
                    Job By Type
                </h4>

                {/* 🔄 Loading */}
                {loading && (
                    <div className="d-flex justify-content-center py-5">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                )}

                {/* ❌ Error */}
                {!loading && error && (
                    <div className="alert alert-danger text-center">
                        {error}
                    </div>
                )}

                {!loading && !error && (
                    <div className="row g-3">
                        {jobsWithDefaults.map((job, index) => (
                            <div key={index} className="col-md-4">
                                <div className="card shadow-sm">
                                    <div className="card-body d-flex justify-content-between align-items-center">
                                        <h6 className="mb-0 text-capitalize fw-semibold">{job.job_type}</h6>
                                        <span className="text-muted">{job.total}</span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default WorkerJobByTypeCount;
